/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable sonarjs/no-duplicate-string */
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from 'antd';

import {
	DetailsHeaderStyled,
	DetailsItemStyled,
	DetailsTextStyled,
	InfoContainerStyled,
} from './ApplicationInfo.styles';

interface ApplicationDetailsM {
	price: string;
	type: string;
	languages: string[];
	downloads: number | null;
	plans: boolean;
}

export const ApplicationInfo: FC<ApplicationDetailsM> = ({ price, type, languages, downloads, plans }) => {
	const { t } = useTranslation();

	return (
		<InfoContainerStyled>
			{!plans && (
				<>
					<Divider type='vertical' style={{ height: `100%`, borderLeft: `1px solid #D9D9D9`, margin: `0` }} />
					<DetailsItemStyled>
						<div>
							<DetailsHeaderStyled>{t(`Marketplace_Price`)}</DetailsHeaderStyled>
							<DetailsTextStyled>{price}</DetailsTextStyled>
						</div>
					</DetailsItemStyled>
				</>
			)}
			<Divider type='vertical' style={{ height: `100%`, borderLeft: `1px solid #D9D9D9`, margin: `0` }} />
			<DetailsItemStyled>
				<div>
					<DetailsHeaderStyled>{t(`Marketplace_Downloads`)}</DetailsHeaderStyled>
					<DetailsTextStyled>{downloads !== null ? downloads : `???`}</DetailsTextStyled>
				</div>
			</DetailsItemStyled>
			<Divider type='vertical' style={{ height: `100%`, borderLeft: `1px solid #D9D9D9`, margin: `0` }} />
			<DetailsItemStyled>
				<div>
					<DetailsHeaderStyled>{t(`Marketplace_Type`)}</DetailsHeaderStyled>
					<DetailsTextStyled>{type}</DetailsTextStyled>
				</div>
			</DetailsItemStyled>
			<Divider type='vertical' style={{ height: `100%`, borderLeft: `1px solid #D9D9D9`, margin: `0` }} />
			<DetailsItemStyled>
				<div>
					<DetailsHeaderStyled>{t(`Marketplace_Languages`)}</DetailsHeaderStyled>
					<DetailsTextStyled>{languages.map(n => n.slice(0, 2)).join(`, `)}</DetailsTextStyled>
				</div>
			</DetailsItemStyled>
			<Divider type='vertical' style={{ height: `100%`, borderLeft: `1px solid #D9D9D9`, margin: `0` }} />
		</InfoContainerStyled>
	);
};
